import { motion } from "framer-motion";

// Плашки «аппарат временно не принимает заказы» / «печать фото недоступна» —
// те же режимы, что управляются из веб-панели/бота (app/api/common/device_commands.py),
// приходят через GET /api/v1/payments/price. Тот же визуальный язык, что и
// WarningMessage (нехватка бумаги), но своя причина и текст.
function ApparatModeWarning({ ordersPaused, photoBlocked, t }) {
    if (!ordersPaused && !photoBlocked) return null;

    const text = ordersPaused
        ? t("editDoc.orders_paused")
        : t("editDoc.photo_unavailable");

    return (
        <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 12 }}
            transition={{ duration: 0.3 }}
            className="flex-none bg-[#F7E1DC] text-[#C2543E] rounded-[1.6vh] py-[1vh] px-[1.8vw] text-[1.35vh] font-bold flex items-center justify-center gap-[1vw]"
        >
            <svg
                className="w-[1.9vh] h-[1.9vh] flex-none"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
            >
                <circle cx="12" cy="12" r="9" />
                <path d="M12 8v5M12 16.5v.01" />
            </svg>
            {text}
        </motion.div>
    );
}

export default ApparatModeWarning;
